import { Fragment } from "react"
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import Home from "../Componentes/Home"
import LoginAhorrador from "../Componentes/Ahorradores/LoginAhorrador"
import GraficosSeguimientos from "../Componentes/Ahorradores/GraficosSeguimiento"
import ClientesHome from "../Componentes/Ahorradores/ClientesHome"
import ProtectedRoute from "./ProtectedRoute"
import FirmarContrato from "../Componentes/Ahorradores/FirmarContrato"
import GuestRoute from "./GuestRoute"



const Rutas = () => {


    return (
        <Router>
            <Fragment>

                <Routes>
                    <Route path="/" element={<Home />} />

                    <Route path="/ahorrador-login" element={ <GuestRoute><LoginAhorrador /></GuestRoute>} />
                    <Route path='/home-clientes' element={<ProtectedRoute><ClientesHome /></ProtectedRoute>}/>
                    <Route path='/seguimiento-ahorro' element={<ProtectedRoute><GraficosSeguimientos /></ProtectedRoute>}/>
                    
                    <Route path="/firmar-contrato" element={<FirmarContrato />}/>
                    {/*<Route element={<ProtectedRoute />}>
                        <Route path="/seguimiento-ahorro" element={<GraficosSeguimientos />}></Route>
                    </Route>*/}

                    
                    

                </Routes>

            </Fragment>
        </Router>
    )



}

export default Rutas